export function titleCase(str) {
  return str
    .split(/_/)
    .join(" ")
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}
